(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Quantity +/- on cart page */
  document.querySelectorAll('[data-change-qty]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.changeQty;
      const delta = parseInt(btn.dataset.delta, 10);
      const input = document.querySelector('[data-qty-input="' + key + '"]');
      if (input) {
        const newVal = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = newVal;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Sort by redirect */
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  'use strict';

  /* ─── Helpers ─── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ─── Determine dropdown top offset after header ─── */
  function positionDropdowns() {
    var header = qs('#site-header');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    var top = rect.bottom;
    qsa('.mega-dropdown').forEach(function (panel) {
      panel.style.top = top + 'px';
    });
  }

  /* ─── Desktop Mega Dropdowns ─── */
  function initDesktopNav() {
    var triggers = qsa('[data-dropdown-trigger]');

    function closeAll(except) {
      triggers.forEach(function (btn) {
        if (btn === except) return;
        btn.setAttribute('aria-expanded', 'false');
        var panelId = btn.getAttribute('aria-controls');
        var panel = qs('#' + panelId);
        if (panel) panel.hidden = true;
      });
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        positionDropdowns();
        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          var p = qs('#' + btn.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          var p2 = qs('#' + btn.getAttribute('aria-controls'));
          if (p2) { p2.hidden = false; }
        }
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          btn.setAttribute('aria-expanded', 'false');
          var p = qs('#' + btn.getAttribute('aria-controls'));
          if (p) p.hidden = true;
          btn.focus();
        }
      });
    });

    /* Close on outside click */
    document.addEventListener('click', function () {
      closeAll(null);
    });

    /* Close on Escape globally */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });

    /* Re-position on scroll/resize if sticky */
    window.addEventListener('scroll', positionDropdowns, { passive: true });
    window.addEventListener('resize', positionDropdowns, { passive: true });
    positionDropdowns();
  }

  /* ─── Header Selectors (lang / currency) ─── */
  function initHeaderSelectors() {
    qsa('.header-selector').forEach(function (sel) {
      var btn = qs('.header-selector__btn', sel);
      var list = qs('.header-selector__list', sel);
      if (!btn || !list) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        /* Close all others */
        qsa('.header-selector').forEach(function (other) {
          var ob = qs('.header-selector__btn', other);
          var ol = qs('.header-selector__list', other);
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (ol) ol.hidden = true;
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          list.hidden = false;
        }
      });
    });

    document.addEventListener('click', function () {
      qsa('.header-selector').forEach(function (sel) {
        var btn = qs('.header-selector__btn', sel);
        var list = qs('.header-selector__list', sel);
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (list) list.hidden = true;
      });
    });
  }

  /* ─── Search Overlay ─── */
  function initSearchOverlay() {
    var overlay = qs('#search-overlay');
    var openBtn = qs('#header-search-btn');
    var closeBtn = qs('#search-overlay-close');
    var backdrop = qs('#search-overlay-backdrop');
    var input = qs('#search-overlay-input');
    if (!overlay || !openBtn) return;

    function openSearch() {
      overlay.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function closeSearch() {
      overlay.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      }
    });
  }

  /* ─── Mobile Drawer ─── */
  function initMobileDrawer() {
    var hamburger = qs('#header-hamburger');
    var drawer = qs('#mobile-drawer');
    var overlay = qs('#mobile-overlay');
    var closeBtn = qs('#mobile-drawer-close');
    if (!hamburger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) { overlay.classList.add('is-open'); overlay.style.display = 'block'; }
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      /* Focus first link */
      var first = qs('.mobile-nav__link', drawer);
      if (first) { setTimeout(function () { first.focus(); }, 280); }
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (overlay) overlay.style.display = '';
      }, 280);
      hamburger.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ─── Mobile Accordion ─── */
  function initMobileAccordion() {
    qsa('[data-mobile-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panelId = btn.getAttribute('aria-controls');
        var panel = qs('#' + panelId);
        if (!panel) return;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
      });
    });
  }

  /* ─── Cart count sync ─── */
  function syncCartCount(count) {
    var badge = qs('#header-cart-count');
    if (!badge) return;
    badge.dataset.count = count;
    if (count > 0) {
      badge.textContent = count > 9 ? '9+' : count;
      badge.classList.remove('cart-badge--hidden');
    } else {
      badge.classList.add('cart-badge--hidden');
    }
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.count !== 'undefined') syncCartCount(e.detail.count);
  });

  /* ─── Init ─── */
  document.addEventListener('DOMContentLoaded', function () {
    initDesktopNav();
    initHeaderSelectors();
    initSearchOverlay();
    initMobileDrawer();
    initMobileAccordion();
  });

})();

  } catch(e) { console.error(e); }
})();
})();
